module.exports = {"TXTCLI_Confirm_Details":{"id":"TXTCLI_Confirm_Details","defaultMessage":"Potvrdit údaje","track":"Confirm Details"}}